<template>
  <div class="all-lb">
    <div class="binding-list" style="display: flex" ref="tableRef">
      <div class="list-header">
        <el-button @click="addClick">新增实盘</el-button>
      </div>
      <div class="list-body">
        <el-table
          :data="entryOrdersData"
          class="tableBoxClass"
          border
          :row-class-name="entryOrdersName"
          style="width: 100%"
          :header-cell-style="{
            background: 'rgba(64, 66, 73, 1)',
            color: 'rgba(237, 189, 136, 1)',
          }"
        >
          <el-table-column
            prop="exchange"
            label="交易所"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column prop="api" label="API" align="center" width="600">
            <template slot-scope="scope">
              <div>
                {{ scope.row.api.split('').fill('*', 3, 10).join('') }}
              </div></template
            >
          </el-table-column>
          <el-table-column
            prop="time"
            label="绑定时间"
            width="200"
            align="center"
          >
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="update"
                @click="updateClick(scope.row)"
                >更新API</el-button
              >
              <el-dialog
                title="更新API"
                :visible.sync="updateDialog"
                class="updateDialog"
                @close="closeupdateDialog"
              >
                <el-form :model="apiForm" :rules="apiRules" ref="apiForm">
                  <el-form-item label="API Key" prop="apiKey">
                    <el-input
                      v-model="apiForm.apiKey"
                      placeholder="请输入API Key"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="API Secret" prop="secretKey">
                    <el-input
                      v-model="apiForm.secretKey"
                      placeholder="请输入API Secret"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="Passphrase"
                    prop="Passphrase"
                    style="display: flex; flex-direction: column"
                    v-show="isPassphrase"
                  >
                    <el-input
                      v-model="apiForm.passphrase"
                      placeholder="请输入Passphrase"
                    ></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="updateDialog = false">取 消</el-button>
                  <el-button type="primary" @click="open">确 定</el-button>
                  <!-- <el-button type="primary" @click="listSubmit('apiForm')"
                    >确 定</el-button
                  > -->
                </div>
              </el-dialog>
              <el-button
                type="text"
                size="small"
                class="delete"
                @click.native.prevent="deleteRow(scope.$index, entryOrdersData)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="pagination">
          <el-pagination background layout="prev, pager, next" :total="1000">
          </el-pagination>
        </div> -->
      </div>

      <div class="total-list-mg">
        <div class="exchange-api">
          <div class="box-tittle">实盘设置</div>
          <div class="box-body-select">
            <el-form ref="form" :model="firmOfferForm" label-width="80px">
              <el-form-item label="资产">
                <el-radio-group v-model="firmOfferForm.allowlabel">
                  <el-radio @change="propertyChange" :label="1"
                    >全部可见</el-radio
                  >
                  <el-radio @change="propertyChange" :label="2"
                    >仅自己可见</el-radio
                  >
                  <el-radio @change="propertyChange" :label="3"
                    >资产不少于我多少比例可见
                  </el-radio>
                  <el-select
                    style="width: 105px"
                    v-model="firmOfferForm.allowPropertyScale"
                    filterable
                    placeholder="输入比例"
                    v-show="firmOfferForm.allowlabel == 3"
                  >
                    <el-option
                      v-for="item in propertyOptions"
                      :key="item.value"
                      :label="item.label + '%'"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="持仓">
                <el-radio-group v-model="firmOfferForm.allowBondsLabel">
                  <el-radio @change="positionChange" :label="1"
                    >全部可见</el-radio
                  >
                  <el-radio @change="positionChange" :label="2"
                    >仅自己可见</el-radio
                  >
                  <el-radio @change="positionChange" :label="3"
                    >资产不少于我多少比例可见</el-radio
                  >
                  <el-select
                    style="width: 105px"
                    v-model="firmOfferForm.allowBondsScale"
                    filterable
                    placeholder="输入比例"
                    v-show="firmOfferForm.allowBondsLabel == 3"
                  >
                    <el-option
                      v-for="item in positionOptions"
                      :key="item.value"
                      :label="item.label + '%'"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-radio-group>
              </el-form-item>

              <el-form-item class="primary">
                <el-button @click="permissionClick('firmOfferForm')"
                  >保存</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- 登陆后判断有没有绑定实盘，没有显示缺省页面 -->
    <div class="default-page" style="display: none" ref="nullRef">
      <div class="default-entrance">
        <img src="../assets/img/rtaLogo/default-page.svg" alt="" />
        <span>你还没有接入实盘</span>
        <el-button @click="addClick">接入实盘</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  sendBindingUpdate,
  deleteBinding,
  getBindingList,
} from '@/api/apiKey.js';
import {
  getBindingExchange,
  sendBinding,
  getPersonalPermission,
  sendPersonalPermission,
} from '@/api/apiKey.js';
export default {
  name: 'FirmManagement',
  //   components: { AreaChart },
  data() {
    return {
      entryOrdersData: [],
      updateDialog: false,
      formLabelWidth: '120px',
      apiForm: {
        apiKey: '',
        secretKey: '',
        passphrase: '',
        id: '',
      },
      isPassphrase: false,
      apiRules: {
        apiKey: [{ required: true, message: '请输入API Key', trigger: 'blur' }],
        secretKey: [
          { required: true, message: '请输入API Secret', trigger: 'blur' },
        ],
      },
      firmOfferForm: {
        allowlabel: '',
        allowProperty: 1,
        allowPropertyScale: 0,
        allowBondsLabel: '',
        allowBonds: 1,
        allowBondsScale: 0,
      },
      propertyOptions: [
        {
          value: '10',
          label: '10',
        },
        {
          value: '20',
          label: '20',
        },
        {
          value: '30',
          label: '30',
        },
        {
          value: '40',
          label: '40',
        },
        {
          value: '50',
          label: '50',
        },
        {
          value: '60',
          label: '60',
        },
        {
          value: '70',
          label: '70',
        },
        {
          value: '80',
          label: '80',
        },
        {
          value: '90',
          label: '90',
        },
        {
          value: '100',
          label: '100',
        },
      ],
      positionOptions: [
        {
          value: '10',
          label: '10',
        },
        {
          value: '20',
          label: '20',
        },
        {
          value: '30',
          label: '30',
        },
        {
          value: '40',
          label: '40',
        },
        {
          value: '50',
          label: '50',
        },
        {
          value: '60',
          label: '60',
        },
        {
          value: '70',
          label: '70',
        },
        {
          value: '80',
          label: '80',
        },
        {
          value: '90',
          label: '90',
        },
        {
          value: '100',
          label: '100',
        },
      ],
      apiNameArr: [],
    };
  },
  created() {
    this.getBindingData();
    this.getPermissionData();
    //发送api请求事件
    this.$EventBus.$on('changeApi', () => {
      this.getBindingData();
    });
  },
  methods: {
    open() {
      this.$confirm('请确保账户权限仅为只读权限', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'warning-confirm',
      })
        .then(() => {
          this.listSubmit('apiForm');
          this.updateDialog = false;
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消更新',
          });
        });
    },
    //奇偶行背景色不同
    entryOrdersName({ rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return 'oddRow';
      }

      return 'evenRow';
    },
    //删除绑定的apikey信息
    deleteRow(index, rows) {
      this.$confirm('', '你确定要删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: '',
        customClass: 'confirm',
      })
        .then(async () => {
          let deleteObj = {
            id: rows[index].id,
          };
          const { data: res } = await deleteBinding(deleteObj);
          //console.log(deleteObj);
          rows.splice(index, 1);
          this.getBindingData();
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //接入实盘
    addClick() {
      this.$router.replace('/NewlyIncreased');
    },
    //获取绑定交易所名单所有数据
    async getBindingData(id) {
      this.entryOrdersData = [];
      const { data: res } = await getBindingList();
      //console.log('绑定交易所名单所有数据:', res.data);
      let bindings = res.data;
      bindings.forEach((item) => {
        this.timeArr = this.dateTypeFormat(
          'YYYY-mm-dd HH:MM',
          new Date(item.createTime)
        );
        const bindingObj = {
          exchange: item.exchange,
          api: item.apiKey,
          time: this.timeArr,
          id: item.id,
          secretKey: item.secretKey,
          passphrase: item.passphrase,
        };
        // const apiNameObj = {
        //   id: item.id,
        //   name: item.name,
        // };
        this.entryOrdersData.push(bindingObj);

        // this.apiNameArr.push(apiNameObj);
      });
      //console.log('要封装的api信息', this.apiNameArr);
      // this.$store.commit('changeApiValue',this.apiNameArr)
      //console.log(this.$store.state.apiNameArr);
      if (this.entryOrdersData.length == 0) {
        this.$refs.tableRef.style.display = 'none';
        this.$refs.nullRef.style.display = 'flex';
      } else {
        this.$refs.tableRef.style.display = 'flex';
        this.$refs.nullRef.style.display = 'none';
      }
    },
    //更新api事件
    updateClick(item) {
      this.apiForm.id = item.id;
      if (item.exchange == 'okx') {
        this.isPassphrase = true;
      }
      this.updateDialog = true;
    },
    //更新api
    listSubmit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let sendUpdateObj = {
            id: this.apiForm.id,
            apiKey: this.apiForm.apiKey,
            secretKey: this.apiForm.secretKey,
            passphrase: this.apiForm.passphrase,
          };
          //console.log('绑定信息', sendUpdateObj);
          const { data: res } = await sendBindingUpdate(sendUpdateObj);

          if (res.code == 0) {
            this.$message({
              message: '更新API成功!',
              type: '更新API成功',
            });
          } else {
            this.$message.error(res.msg);
            this.sendUpdateObj = [];
            this.updateDialog = false;
          }
        }
      });

      // console.log('返回内容：', res);
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeupdateDialog() {
      this.apiForm = {};
      this.isPassphrase = false;
    },
    //获取用户上次设置允许用户查看资产及持仓的权限
    async getPermissionData() {
      const { data: res } = await getPersonalPermission();

      this.firmOfferForm.allowPropertyScale = res.data.allowPropertyScale;
      this.firmOfferForm.allowBondsScale = res.data.allowBondsScale;

      this.firmOfferForm.allowBonds = res.data.allowBonds;
      this.firmOfferForm.allowProperty = res.data.allowProperty;

      if (res.data.allowBonds == true || res.data.allowProperty == true) {
        if (res.data.allowBondsScale == 0) {
          this.firmOfferForm.allowBondsLabel = 1;
        } else {
          this.firmOfferForm.allowBondsLabel = 3;
        }
        if (res.data.allowPropertyScale == 0) {
          this.firmOfferForm.allowlabel = 1;
        } else {
          this.firmOfferForm.allowlabel = 3;
        }
      }

      if (res.data.allowBonds == false) {
        this.firmOfferForm.allowBondsLabel = 2;
      }
      if (res.data.allowProperty == false) {
        this.firmOfferForm.allowlabel = 2;
      }
    },
    //保存实盘设置
    async permissionClick() {
      let permissonObj = {
        allowProperty: this.firmOfferForm.allowProperty,
        allowPropertyScale: this.firmOfferForm.allowPropertyScale,
        allowBonds: this.firmOfferForm.allowBonds,
        allowBondsScale: this.firmOfferForm.allowBondsScale,
      };
      const { data: res } = await sendPersonalPermission(permissonObj);
      //console.log('实盘设置', permissonObj);
      this.$message({
        showClose: true,
        message: res.msg,
        type: 'success',
      });
      //console.log('设置的权限：', permissonObj);
    },
    //资产
    propertyChange() {
      //console.log('testA', this.firmOfferForm.allowlabel);
      if (this.firmOfferForm.allowlabel == 1) {
        this.firmOfferForm.allowProperty = true;
        this.firmOfferForm.allowPropertyScale = 0;
      } else if (this.firmOfferForm.allowlabel == 2) {
        this.firmOfferForm.allowProperty = false;
      } else {
        this.firmOfferForm.allowProperty = true;
      }
    },
    //持仓
    positionChange() {
      if (this.firmOfferForm.allowBondsLabel == 1) {
        this.firmOfferForm.allowBonds = true;
        this.firmOfferForm.allowBondsScale = 0;
      } else if (this.firmOfferForm.allowBondsLabel == 2) {
        this.firmOfferForm.allowBonds = false;
      } else {
        this.firmOfferForm.allowBonds = true;
      }
    },
  },
};
</script>

<style lang="scss" scope>
.all-lb {
  width: 1200px;
  margin: 0 auto !important;
  height: 100%;
  //text-align: center;
  display: flex;
  flex-direction: column;
  .binding-list {
    height: 100%;
    width: 100%;
    flex-direction: column;
    .list-header {
      margin-top: 50px;
      display: flex;
      justify-content: flex-end;
      height: 100%;
      .el-button {
        width: 88px;
        height: 32px;
        background: #edbd88;
        border-radius: 4px;
        line-height: 32px;
        padding: 0 !important;
        border: none;
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #33353e;
          line-height: 32px;
        }
      }
    }
    .list-body {
      margin-top: 20px;
      .el-table,
      .el-table__expanded-cell {
        background-color: transparent;
      }

      .el-table th,
      .el-table tr {
        background-color: transparent;
      }
      .tableBoxClass {
        border: none !important;
        border-radius: 8px !important;
        tbody tr:hover > td {
          background-color: rgba(255, 255, 255, 0.1) !important;
          color: #d1d4dc !important;
        }
        th {
          background-color: rgba(64, 66, 73, 1) !important;
          padding: 0 !important;
          height: 48px !important;
          line-height: 48px !important;
        }
        td {
          padding: 0 !important;
          height: 48px !important;
          line-height: 48px !important;
          .cell {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #d1d4dc;
          }
        }
        .el-table__header-wrapper {
          //border: none !important;
          //border-radius: 8px 8px 0 0 !important;
          display: flex !important;
        }
        .el-table__body-wrapper {
          border-radius: 0 !important;
          .el-table__body {
            .el-table__row {
              .el-table__cell {
                .cell {
                  .update {
                    margin-right: 20px;
                    span {
                      font-size: 14px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: #00ae93;
                      line-height: 16px;
                    }
                  }
                  .delete {
                    span {
                      font-size: 14px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: #f7525f;
                      line-height: 16px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .pagination {
        margin-top: 40px;
        text-align: center;
        .el-pagination.is-background .btn-next,
        .el-pagination.is-background .btn-prev,
        .el-pagination.is-background .el-pager li {
          margin: 0 5px;
          background-color: rgba(61, 63, 72, 1) !important;
          color: #d1d4dc;
          min-width: 32px;
          min-height: 32px;
          border-radius: 2px;
        }
        .el-pagination {
          .el-pager {
            li {
              padding: 4px 4px;
            }
          }
          .el-pager li:not(.disabled):hover {
            color: rgba(51, 53, 62, 1) !important;
            background: #edbd88 !important;
          }
          .el-pager li:not(.disabled).active {
            color: rgba(51, 53, 62, 1) !important;
            background: #edbd88 !important;
          }
        }
      }
    }
    .total-list-mg {
      margin-top: 48px;
      background: rgba(159, 159, 159, 0.1);
      border-radius: 8px;
      width: 100%;
      height: 100%;
      margin-bottom: 32px;
      .exchange-api {
        padding: 24px 40px 24px 40px;
        .box-tittle {
          font-size: 20px;
          font-family: Roboto-Bold, Roboto;
          font-weight: bold;
          color: #d1d4dc;
          line-height: 24px;
        }
        .box-body {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-top: 20px;
          .el-form {
            display: flex;
            justify-content: space-between;
            width: 100%;
            .exchange-select {
              width: 200px;
              height: 358px;
              background: #33353e;
              border-radius: 8px;
              margin-right: 20px;
              .el-form-item {
                .el-form-item__label {
                  font-size: 16px;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: #d1d4dc;
                  line-height: 19px;
                  text-align: left;
                  margin: 24px 0 12px 20px;
                }
              }
              .exchange-bnt {
                display: flex;
                flex-direction: column;
                .el-form-item__content {
                  display: flex;
                  flex-direction: column;
                  margin-top: 0 !important;
                  .el-button {
                    width: 160px;
                    height: 48px;
                    background: rgba(255, 255, 255, 0.1);
                    border-radius: 4px;
                    border: none;
                    padding: 0;
                    margin: 8px 0 0 20px;
                    text-align: left;

                    span {
                      line-height: 48px;
                      display: flex;
                      .im {
                        margin: 0 8px 0 20px;
                        img {
                          margin-top: 14px;
                        }
                      }
                    }
                  }
                  .el-radio-group {
                    .el-radio-button {
                      width: 160px !important;
                      height: 48px;
                      background: rgba(255, 255, 255, 0.1);
                      border-radius: 4px;
                      border: none;
                      padding: 0;
                      margin: 8px 0 0 20px;
                      text-align: left;
                      .el-radio-button__inner {
                        padding: 0 0 !important;
                        width: 160px !important;
                        height: 48px;
                        background: rgba(255, 255, 255, 0.1);
                        -webkit-box-shadow: -1px 0 0 0 rgba(255, 255, 255, 0.1);
                        border-radius: 4px;
                        border: none;
                        font-size: 18px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #d1d4dc;
                        line-height: 48px;
                      }
                      .el-radio-button__inner:focus {
                        //background: rgba(237, 189, 136, 0.1);
                        border-radius: 4px;
                        border: 1px solid #edbd88;
                      }
                      .el-radio-button__orig-radio:checked
                        + .el-radio-button__inner {
                        background: rgba(237, 189, 136, 0.1);
                        border-radius: 4px;
                        border: 1px solid #edbd88;
                      }
                      span {
                        line-height: 48px;
                        display: flex;
                        padding: 0 1;
                        .im {
                          margin: 0 8px 0 20px;
                          img {
                            margin-top: 14px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            .fill-in-api {
              width: 900px;
              height: 358px;
              background: #33353e;
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              .set-up {
                display: flex;
                justify-content: space-between;
                height: 22px;
                padding: 24px 20px;
                span {
                  font-size: 16px;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: #d1d4dc;
                  line-height: 19px;
                }
                a {
                  font-size: 16px;
                  font-family: Roboto-Medium, Roboto;
                  font-weight: 500;
                  color: #edbd88;
                  line-height: 19px;
                  text-decoration: none;
                }
              }
              .el-form-item {
                margin: 0 20px 32px 20px;
                .el-form-item__label {
                  font-size: 14px;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: #d1d4dc;
                  line-height: 16px;
                }
                .el-form-item__content {
                  .el-input {
                    margin-top: 12px;
                    .el-input__inner {
                      width: 860px;
                      height: 40px;
                      background: rgba(255, 255, 255, 0.1);
                      border-radius: 4px;
                      border: none;
                      color: #d1d4dc;
                    }
                    .el-input__inner::placeholder {
                      color: rgba(209, 212, 220, 0.6);
                    }
                    .el-input__inner:focus {
                      border: 1px solid #edbd88 !important;
                    }
                  }
                }
              }
            }
            .primary {
              margin-top: 24px;
              text-align: right;
              margin-bottom: 0 !important;
              .el-form-item__content {
                .el-button {
                  width: 72px;
                  height: 32px;
                  background: #edbd88;
                  border-radius: 4px;
                  border: none;
                  line-height: 32px;
                  padding: 0;
                  span {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #33353e;
                  }
                }
              }
            }
          }
        }
        .box-body-select {
          margin-top: 20px;
          .el-form {
            .el-form-item {
              height: 32px;
              line-height: 32px;
              margin-bottom: 8px;
              .el-form-item__label {
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: #ffffff;
                height: 32px;
                line-height: 32px;
              }
              .el-form-item__content {
                height: 32px;
                line-height: 32px;
                .el-radio-group {
                  .el-radio {
                    .el-radio__input {
                      .el-radio__inner {
                      }
                    }
                    .el-radio__input.is-checked .el-radio__inner {
                      border: 1px solid #edbd88;
                      background: transparent;
                    }
                    .el-radio__inner::after {
                      width: 8px;
                      height: 8px;
                      border-radius: 100%;
                      background-color: #edbd88;
                    }
                    .el-radio__inner:hover {
                      border-color: #edbd88;
                    }
                    .el-radio__label {
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: rgba(255, 255, 255, 0.65);
                    }
                  }
                  .el-select {
                    .el-input {
                      .el-input__inner {
                        height: 32px !important;
                        background: rgba(159, 159, 159, 0.1) !important;
                        border-radius: 4px !important;
                        border: 1px solid rgba(209, 212, 220, 0.5) !important;
                        font-size: 14px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: rgba(255, 255, 255, 0.65);
                      }
                    }
                  }
                }
              }
            }
            .primary {
              margin-bottom: 0 !important;
              margin-top: 24px;
              text-align: right;
              .el-form-item__content {
                .el-button {
                  width: 72px;
                  height: 32px;
                  background: #edbd88;
                  border-radius: 4px;
                  border: none;
                  line-height: 32px;
                  padding: 0;
                  span {
                    font-size: 14px;
                    font-family: MicrosoftYaHei;
                    color: #33353e;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .default-page {
    margin: 65px 100px;
    text-align: center;
    .default-entrance {
      margin: 148px 340px;
      display: flex;
      flex-direction: column;
      span {
        margin-top: 32px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #d1d4dc;
        line-height: 19px;
      }
      .el-button {
        width: 320px;
        height: 40px;
        margin-top: 40px;
        background: #edbd88;
        border-radius: 4px;
        padding: 0;
        border: none;
        span {
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #33353e;
        }
      }
    }
  }
}
</style>
<style lang="scss" >
.oddRow {
  //斑马纹样式

  color: white;
  height: 48px !important;
  background-color: rgba(64, 66, 73, 1) !important;
  border-radius: 0 !important;
}

.evenRow {
  background-color: rgba(80, 82, 89, 1) !important;
  height: 48px !important;
  color: white;
  border-radius: 0 !important;
}
th {
  height: 48px !important;
  line-height: 48px !important;
}
td {
  height: 48px !important;
  line-height: 48px !important;
}
.updateDialog {
  .el-dialog {
    width: 900px;

    background: #33353e !important;
    border-radius: 8px;
    .el-dialog__header {
      width: 860px;
      height: 70px;
      text-align: left;
      margin: 0 20px;
      .el-dialog__title {
        line-height: 71px;
        font-size: 16px;
        font-family: Roboto-Bold, Roboto;
        font-weight: bold;
        color: #d1d4dc;
      }
    }
    .el-dialog__body {
      height: 100% !important;
      width: 860px;
      margin: 0 20px;
      margin: 8px 20px 16px 20px;
      .el-form {
        .el-form-item {
          margin: 0 0 32px 0;
          .el-form-item__label {
            font-size: 14px;
            font-family: Roboto-Regular, Roboto;
            font-weight: 400;
            color: #d1d4dc;
            line-height: 16px;
          }
          .el-form-item__content {
            width: 860px !important;
            .el-input {
              margin-top: 12px;
              .el-input__inner {
                height: 40px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 4px;
                border: none;
                padding: 0 12px !important;
                color: #d1d4dc;
              }
              .el-input__inner::placeholder {
                color: rgba(209, 212, 220, 0.6);
              }
              .el-input__inner:focus {
                border: 1px solid #edbd88 !important;
              }
            }
          }
        }
      }
    }
    .el-dialog__footer {
      width: 100% !important;
      height: 100% !important;
      padding: 0 !important;
      .dialog-footer {
        padding: 8px 20px 20px;
        .el-button {
          line-height: 32px !important;
          width: 72px;
          height: 32px !important;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          background: rgba(51, 53, 62, 1);
          margin: 0 0 0 12px !important;
          padding: 0 !important;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #d1d4dc;
          }
        }
        .el-button--primary {
          background: #edbd88 !important;
          border: none;
          span {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #33353e;
          }
        }
      }
    }
  }
}
.el-message-box__wrapper {
  .warning-confirm {
    width: 300px !important;
    height: 155px !important;
    .el-message-box__header {
      padding: 16px 26px 25px 22px !important;
      height: 26px;
      .el-message-box__title {
        width: 320px !important;
        span {
          width: 64px;
          height: 24px;
          font-size: 16px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.85);
          line-height: 24px;
        }
      }
      .el-message-box__headerbtn {
        top: 26px !important;
        right: 26px !important;
        .el-message-box__close {
        }
      }
    }
    .el-message-box__content {
      padding: 0 15px 25px 22px !important;
      .el-message-box__container {
        .el-message-box__message {
          p {
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: rgba(255, 255, 255, 0.65);
            line-height: 22px;
          }
        }
      }
    }
    .el-message-box__btns {
      height: 24px !important;
      padding: 0 26px 16px 15px !important;
      .el-button {
        width: 49px;
        height: 24px;
        border-radius: 2px;
        background: #33353e;
        border: 1px solid rgba(255, 255, 255, 0.2);
        span {
          font-size: 13px;
          font-family: MicrosoftYaHei;
          color: rgba(255, 255, 255, 0.65);
        }
      }
      .el-button--primary {
        background: #edbd88;
        span {
          color: #33353e;
        }
      }
      .el-button--small {
        padding: 0;
      }
    }
  }
}
.el-message-box__wrapper {
  .confirm {
    width: 300px !important;
    height: 107px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/FirmManagement.vue